import React from 'react';
import { Button, Divider } from '@cad-arc';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FREventPageFooter } from '../fr-event-common-components/fr-event-page-footer';
import { useGetEventIdAndTabNameFromParams } from '../fr-event-details-page/hooks/use-get-event-id-and-tab-name-from-params';
import { useEventMetadataStore } from '../event-panel/event-panel-form/event-metadata';
import { AttachmentsPreview } from '../attachments/attachments-preview';
import { AttachmentSortOptionValue } from '../attachments/types';
import { DEFAULT_ATTACHMENT_SORT_OPTION_VALUE } from '../attachments/constants';
import { FrAttachmentsPageLayout } from '../attachments/fr-attachments-page-layout';
import { useIsClearedEvent } from '~/event-panel/event-panel-form/use-is-cleared-event';

export function FrEventAttachmentsPage() {
    const { eventId } = useGetEventIdAndTabNameFromParams();
    const { attachmentId } = useParams<{ attachmentId: string }>();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const eventMetadataStore = useEventMetadataStore();
    const isClearedEvent = useIsClearedEvent();
    const eventMetadata = eventMetadataStore.state.metadata;

    const sortOption =
        (searchParams.get('sortOption') as AttachmentSortOptionValue) ||
        DEFAULT_ATTACHMENT_SORT_OPTION_VALUE;

    const handleGoBack = () => {
        navigate(-1);
    };
    return (
        <FrAttachmentsPageLayout footer={<FREventPageFooter hideMoreDetailsBtn />}>
            <Button variant="outline" leadingVisual="ArrowLeft" onClick={handleGoBack}>
                Back to Event Attachments
            </Button>
            {eventId && (
                <>
                    <Divider />
                    <AttachmentsPreview
                        entityId={eventId?.toString() || ''}
                        entityType="CAD_AGENCY_EVENT"
                        entityNumber={eventMetadata?.agencyEventNumber}
                        attachmentId={attachmentId ? Number(attachmentId) : undefined}
                        sortOption={sortOption}
                        isClearedEvent={isClearedEvent}
                    />
                </>
            )}
        </FrAttachmentsPageLayout>
    );
}
